/**
 * Angular imports.
 */
import { ChangeDetectionStrategy,ChangeDetectorRef, Component, EventEmitter, Input, Output, OnInit, ViewChild, ElementRef, OnChanges, SimpleChanges, NgZone, OnDestroy } from '@angular/core';
/**
 * Constant imports.
 */
import { NO_INFO_TYPE, NUMBERS, THUMBNAIL_HIGHLIGHTER_SIZE, STORY_TYPES, STORY_BACKGROUND_CODES } from 'src/app/constants/app.constants';
import { OnChange } from 'src/app/custom-decorators/ngOnchanges.Decorator';


/**
 * service imports
 */
import { FunCollectionService } from 'src/app/common/common-functions/fun-collection.service';
import { UserStoryService } from 'src/app/dataservices/userStory/user-story.service';
import { Subscription } from 'rxjs';
/**
 * Show the thumbnail for the list and creation.
 */
@Component({
  selector: 'app-thumbnail-views',
  templateUrl: './thumbnail-views.component.html',
  styleUrls: ['./thumbnail-views.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThumbnailViewsComponent implements OnInit, OnDestroy  {
  isTagMetaGenerated: boolean;
  tagMetaContent: null;

  constructor(private storyServ: UserStoryService, private zone: NgZone,
    private funCollectionService: FunCollectionService, private cd: ChangeDetectorRef)
 {

 }
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
  /**
   * Get the detail for the thumbnail.
   * Flag to identify is in creation mode or not.
   * Thumbnail text.
   * Thumbnail tag users list.
   * Thumbnail product img.
   * Basic thumbnail like src or gradient.
   * No Info available for the thumbnail src.
   */
  @Input() thumbnailInfo;
  @Input() viewCount;
  @Input() isCreationMode: boolean;
  @Input() typingText: string;
  @Input() tagUsers: any = [];
  @Input() productImage;
  @Input() productData: any;
  @Input() productType: any;
  @Input() thumbnail: { src: string, gradient: string };
  @Input() noInfoSrc: string;
  @Input() storyType: string;
  @Input() listing = false;
  @Input() isMe: boolean;
  @Input() backgroundCode;
  @Input() backGroundImage;
  @Input() youText: string;

  @Input() isPharmaRepost = false;

  @Input() activeStatus: boolean;

  @Input() isTagFeatureInUse: boolean;

  @Input() viewPostText: string;

  @OnChange<void>('onActiveStoryIndexChange')
  @Input() activeIndex;

  @Input() targetInfo;

  @Input()  viewMode = false;
  /**
   * Emit the generated meta.
   */
  @Output() emitGenerateMeta: EventEmitter<any> = new EventEmitter();

  @Output() emitToggleProgressCounter: EventEmitter<boolean> = new EventEmitter();

  @Output() emitRemoveTag: EventEmitter<any> = new EventEmitter();

  @Output() onGenrateTagMeta: EventEmitter<any> = new EventEmitter();

  @Output() emitOnMeta: EventEmitter<any> = new EventEmitter();

  @Output() deepLinkRedirectEmit: EventEmitter<any> = new EventEmitter();

  @Output() profileRedirectEmit: EventEmitter<any> = new EventEmitter();


  @Output() lockScreen: EventEmitter<boolean> = new EventEmitter();
  
  private subscriptions: Subscription = new Subscription();
  /**
   * No Info type constant.
   * 0 for the whole list
   * 1 for the single view detail
   * 2 for the thumbnail.
   */
  public NO_INFO_TYPE = NO_INFO_TYPE;

  /**
   * Numbers constant.
   */
  public numbers = NUMBERS;

  public productImageLoaded = false;

  public backGroundImageLoaded = false;

  /**
   * Highlighter size.
   */
  public highlighterSize = THUMBNAIL_HIGHLIGHTER_SIZE;

  public STORY_TYPE = STORY_TYPES;

  public currentTag: any;

  public isTagMeta: boolean;

  /**
   * loader state
   */
  public showLoader = false;
  /**
   * flag for product meta
   */
  productMeta = false;
  /**
   * Get the status for the active highlighter.
   */
  get getActiveStatus(): boolean {
    return this.thumbnailInfo.viewed === 1;
  }
  //remove tag 
  public removeTag(event):  void {
    this.emitRemoveTag.emit(event);
  }
  generateMeta(event): void {
    this.emitGenerateMeta.emit(event);
  }
  onActiveStoryIndexChange(): void {
    this.productImageLoaded = false;
    this.backGroundImageLoaded = false;
    this.currentTag = '';
    this.isTagMeta = false;
    this.generateMeta(false);
    this.lockScreen.emit(false);
  }
  /**
   * 
   * @param event generate meta for image
   */
  generateProductMeta(event): void {
    if (this.isTagMeta) {
      this.restoreView();
    }
   else if (event) {
      this.productMeta = true;
      this.generateMeta(event);
      this.lockScreen.emit(true);
      this.cd.markForCheck();
    }
    else {
      this.restoreView();
    }
  }
  generateTagMeta(event) {
    if (this.productMeta) {
      this.restoreView();
    }
    else if (event) {
      this.isTagMeta = true;
      this.currentTag = event;
      this.generateMeta(event);
      this.lockScreen.emit(true);
      this.cd.markForCheck();
    }
  }
  onMeta(event): void {
    if (this.productMeta) {
      this.deepLinkRedirectEmit.emit(event);
    }
    else if (this.isTagMeta) {
      this.profileRedirectEmit.emit(event);
    }
  }
  getClass(backgroundCode, creationMode): any {
    if (backgroundCode) {
      if (STORY_BACKGROUND_CODES.filter(value => {
        if (value.src === backgroundCode)
        return;
      })) {
        return backgroundCode;
      }
    }
    return;
  }
  getGradient(code): any {
    let gradient = '';
    if (STORY_BACKGROUND_CODES.filter(value => {
      if (value.src === code) {
        gradient = value.gradient;
      }
    })) 
    return gradient;
  }
  public getBacKGroundStyle() {
     if (this.listing) {
      return {
        'background-image': 'url(' + this.backGroundImage + '), url(assets/images/grandround/image_placeholder.svg)'
      };
     }
     else if (this.backGroundImage && ( this.storyType === this.STORY_TYPE.TEMPLATE || this.storyType === this.STORY_TYPE.PHARMA || this.storyType === this.STORY_TYPE.PHARMAREPOST)) {
      const gradient = this.getGradient(this.backgroundCode);
      let backGroundUrl = '';
      if (this.backGroundImage.indexOf('http') !== -1 || this.backGroundImage.indexOf('base64') !== -1) {
        backGroundUrl = this.backGroundImage;
      }
      else {
          backGroundUrl =this.storyServ.fileCodeUrlMap.get(this.backGroundImage);
        }
        if (this.backGroundImageLoaded === false) {
          this.emitToggleProgressCounter.emit(true);
          this.showLoader = true;
          this.cd.markForCheck();
           this.waitForImages(backGroundUrl).then(data => {
            this.emitToggleProgressCounter.emit(false);
            this.backGroundImageLoaded = true;
             this.showLoader = false;
            this.cd.markForCheck();
          });
          if (gradient) {
            return {
              'background-image': 'linear-gradient('+ gradient + ')',
              'background-repeat': 'no-repeat',
              'background-size': 'contain',
              'background-position': 'center'
            };
          }
        }
        else {
          if (gradient) {
            return {
              'background-image': 'url(' + backGroundUrl + '), linear-gradient('+ gradient + ')',
              'background-repeat': 'no-repeat',
              'background-size': 'contain',
              'background-position': 'center'
            };
          }
          else {
            return {
              'background-image': 'url(' + backGroundUrl + ')',
              'background-repeat': 'no-repeat',
              'background-size': 'contain',
              'background-position': 'center'
            };
          }
        }
     }
     else if (!this.backGroundImage) {
      this.backGroundImageLoaded = true;
     }
    this.cd.markForCheck();
  }
  /**
   * to decode product imagte file code
   */
  public getProductImage(): string {
    if (this.storyType != STORY_TYPES.TEMPLATE && this.storyType !=STORY_TYPES.PHARMA && this.storyType != STORY_TYPES.PHARMAREPOST) {
      let productUrl = '';
      if (this.productImage.indexOf('http') !== -1 || this.productImage.indexOf('base64') !== -1) {
        productUrl =  this.productImage ? this.productImage : 'assets/images/grandround/image_placeholder.svg';
      }
      else {
         productUrl = this.storyServ.fileCodeUrlMap.get(this.productImage);
         productUrl = productUrl ? productUrl : 'assets/images/grandround/image_placeholder.svg';
      }
      if (this.productImageLoaded === false) {
        this.emitToggleProgressCounter.emit(true);
        this.showLoader = true;
        this.cd.markForCheck();
        this.waitForImages(productUrl).then(data => {
          this.emitToggleProgressCounter.emit(false);
          this.productImageLoaded = true;
           this.showLoader = false;
          this.cd.markForCheck();
        });
      }
      else if (this.productImageLoaded === true) {
        return productUrl;
      }
    }
    else {
      this.productImageLoaded =true;
    }
    return;
  }
  waitForImages(productUrl): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const img = new Image();
      img.src = productUrl;
      if (productUrl) {
        img.onload = () => {
          resolve();
        };
        img.onerror = () => reject(`Failed to preload image: ${productUrl}`);
      }
    });
  }

  /**
   * restore view 
   */
  restoreView(): void {
    if (this.isTagMeta === true) {
      this.isTagMeta = false;
      this.currentTag === null;
      this.generateMeta(false);
      this.lockScreen.emit(false);
      this.cd.markForCheck();
      this.cd.detectChanges();
    }
    if (this.productMeta) {
      this.productMeta = false;
      this.generateMeta(false);
      this.lockScreen.emit(false);
      this.cd.markForCheck();
      this.cd.detectChanges();
    }
  }
  ngOnInit(): void {
    this.subscriptions.add(this.storyServ.storyDataChanged.subscribe(data => {
      this.cd.markForCheck();
      this.cd.detectChanges();
    }));

    this.subscriptions.add(this.storyServ.creation_view_update.subscribe(data => {
      this.cd.markForCheck();
      this.cd.detectChanges();
    }));
    this.subscriptions.add(this.storyServ.StoryshowLoader.subscribe(data => {
      if (data) {
        this.emitToggleProgressCounter.emit(true);
      }
      this.showLoader = data;
      if (!data) {
        this.emitToggleProgressCounter.emit(false);
      }
      this.cd.markForCheck();
    }));

  }
}
